import { MultiSelect } from "react-multi-select-component";
import { PaginationControls } from "../../../../hooks/customHook/paginationHook/usePagination";
import DataTable from "react-data-table-component";
import { customStyles } from "../../../../assets/table-style";
import { useServerPagination } from "../../../../hooks/customHook/paginationHook/useServerPagination";
import BASE_URL from "../../../../assets/global/url";
import React, { useState, useEffect, useContext, useRef } from "react";
import { RefreshContext } from "./NewInvoice";
import BackloadModal from "./BackloadModal";
import format from "date-fns/format";
import swal from "sweetalert";
import { useNavigate } from "react-router-dom";
import axios from "axios";

import FilterStore from "../../../../hooks/customHook/FilterStore";
import { formatCurrency, parseNumber } from "../../../../utils/numberFormatter";
import { NoTranslate } from "../../../../helper/prevent_translate_browser";
import { useServerSort } from "../../../../hooks/customHook/sortingHook/useTableSort";
const ApprovedStatusTab = () => {
  const navigate = useNavigate();
  const statusProps = useContext(RefreshContext);
  const {
    selectedCutOff,
    setSelectedCutOff,
    currencyId,
    fetchCutOff,
    userLoggedID,
    authrztn,
    clearFilterSignal,
  } = statusProps;

  // For backload
  const [showBackloadModal, setShowBackloadModal] = useState(false);
  const [selectedInvoiceData, setSelectedInvoiceData] = useState({
    invoiceId: null,
    transactionId: null,
  });

  // For table action button
  const [openMenuId, setOpenMenuId] = useState(null);
  const [rotatedId, setRotatedId] = useState(null);

  // PARA ITO SA FILTER RETENTION
  //START
  // For search filter
  const [searchTerm, setSearchTerm] = useState(() =>
    FilterStore.NIgetSearch("invoice_returned"),
  );
  useEffect(() => {
    FilterStore.NIsaveSearch(searchTerm, "invoice_returned");
  }, [searchTerm]);
  const [filterColumn, setFilterColumn] = useState(() =>
    FilterStore.getFilterColumn(),
  );

  // Tracks synchronously whether a search is active.
  // Using a ref (not state) so Feature 2's useEffect reads the up-to-date
  // value immediately — before React flushes the setSearchTerm("") update —
  // preventing the race where stale "834" closure fires the date-expand
  // effect right after the user clears the input.
  const isSearchActiveRef = useRef(!!searchTerm);
  const debounceTimer = useRef(null);
  const pageRestored = useRef(false);

  // Reset all local filters when parent fires Clear Filter
  useEffect(() => {
    if (!clearFilterSignal) return; // skip on initial mount (signal === 0)
    setSearchTerm("");
    setDebouncedSearchTerm("");
    setSelectedCustomer([]);
    setFilterColumn("all");
    isSearchActiveRef.current = false;
    lastSearchCutoffRef.current = { from: null, to: null };
    FilterStore.NIsaveSearch("", "invoice_returned");
    FilterStore.saveSelected([]);
    FilterStore.saveFilterColumn("all");
  }, [clearFilterSignal]);
  // Tracks the last from/to dates that Feature 2 pushed into selectedCutOff.
  // Used to skip setSelectedCutOff when the dates haven't changed, which
  // breaks the infinite loop: Feature 2 sets cutoff → main effect re-fetches
  // → new data array ref → Feature 2 fires again → same dates → STOP.
  const lastSearchCutoffRef = useRef({ from: null, to: null });

  // Debounced version of searchTerm — this is what actually triggers API calls.
  // searchTerm updates immediately (for the input display); debouncedSearchTerm
  // waits 600 ms after the user stops typing before firing the effect → fetch.
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState(searchTerm);

  // ADDED useEffect to persist it:
  useEffect(() => {
    FilterStore.saveFilterColumn(filterColumn);
  }, [filterColumn]);

  // For customer filter
  const [selectedCustomer, setSelectedCustomer] = useState(
    () => FilterStore.getSelected(), ////getcustomer value
  );
  /// save value customer hook
  useEffect(() => {
    FilterStore.saveSelected(selectedCustomer);
  }, [selectedCustomer]);
  //END
  const [customerList, setCustomerList] = useState([]);
  const [customerSearchValue, setCustomerSearchValue] = useState("");

  // For data table columns
  const columns = [
    {
      name: "Transaction ID",
      selector: (row) => row.client_transaction_id,
      sortField: "client_transaction_id",
      cell: (row) => (
        <div className="text-nowrap text-center">
          <NoTranslate>{row.client_transaction_id}</NoTranslate>
        </div>
      ),
      conditionalCellStyles: [
        {
          when: (row) =>
            row.client_transaction_id &&
            row.client_transaction_id.startsWith("ROT-"),
          style: {
            color: "#16c03d",
          },
        },
      ],
    },
    {
      name: "Destination",
      selector: (row) => row.destination,
      sortField: "destination",
      cell: (row) => <div className="text-center">{row.destination}</div>,
    },
    {
      name: "Container Number",
      selector: (row) => row.container_number,
      sortField: "container_number",
      cell: (row) => <div>{row.container_number || "n/a"}</div>,
    },
    {
      name: "Pier",
      selector: (row) => row.pier,
      sortField: "pier",
      cell: (row) => <div>{row.pier || "n/a"}</div>,
    },
    // {
    //   name: "Customer",
    //   selector: (row) =>
    //     row.customer.first_name && row.customer.last_name
    //       ? `${row.customer.first_name} ${row.customer.last_name}`
    //       : `${row.customer.company_name}`,
    // },
    {
      name: "Customer",
      sortField: "customer",
      cell: (row) => (
        <NoTranslate>
          {/* Company name first, else first name + last name (last name only if available) */}
          {row.customer.company_name ||
            [row.customer.first_name, row.customer.last_name]
              .filter(Boolean)
              .join(" ")}
        </NoTranslate>
      ),
    },
    {
      name: "Invoice Date",
      sortField: "invoice_date",
      selector: (row) => format(row.invoice_date, "MMM/dd/yyyy"),
    },
    {
      name: "Date Approved",
      sortField: "date_approved",
      selector: (row) =>
        row.date_approved
          ? format(row.date_approved, "MMM/dd/yyyy hh:mm a")
          : "n/a",
    },
    {
      name: "Due Date",
      sortField: "due_date",
      selector: (row) => row.daysDifference,
    },
    {
      name: "DR Number",
      sortField: "dr_number",
      selector: (row) => row.dr_number || "n/a",
    },
    {
      name: "PO Number",
      sortField: "po_number",
      selector: (row) => row.po_number || "n/a",
    },

    // {
    //   name: "Currency",
    //   selector: (row) => row.currency.currency_name,
    // },
    // {
    //   name: "Currency Rate",
    //   selector: (row) => row.rate,
    // },
    {
      name: "Total Amount",
      selector: (row) => row.total_amount,
      sortField: "total_amount",
      cell: (row) => {
        const isROT =
          row.client_transaction_id &&
          row.client_transaction_id.startsWith("ROT-");
        const amount = parseNumber(row.total_amount) || 0;

        if (isROT) {
          const isNegative = amount < 0;
          const isPositive = amount > 0;

          return (
            <div
              className="text-center"
              style={{
                color: isNegative ? "red" : isPositive ? "green" : "inherit",
                fontWeight: "bold",
              }}
            >
              {isPositive ? "+" : ""}
              {formatCurrency(amount, row.currency?.currency_name)}
            </div>
          );
        }

        return (
          <div className="text-center">
            <NoTranslate>
              {formatCurrency(amount, row.currency?.currency_name)}
            </NoTranslate>
          </div>
        );
      },
    },
    {
      name: "Status",
      sortField: "status",
      selector: (row) => row.status,
      cell: (row) => {
        let color;
        switch (row.status) {
          case "Pending":
            color = "#FFA500";
            break;
          case "Approved":
            color = "#3B9F3F";
            break;
          case "Returned":
          case "Rejected":
            color = "#FF0000";
            break;
          default:
            color = "initial";
        }
        return (
          <div
            style={{
              padding: "5px 10px",
              borderRadius: "5px",
              color: color,
              textTransform: "uppercase",
              fontWeight: "bold",
            }}
          >
            {row.status}
          </div>
        );
      },
    },
  ];

  if (authrztn.includes("Invoices-Delete")) {
    columns.push({
      name: "Action",
      selector: (row) => {
        const status = row.status;
        const isReturned = status === "Returned";
        const isPending = status === "Pending";
        return (
          <div className="d-flex align-items-center gap-2 p-3">
            <button
              type="button"
              className="border-0 bg-transparent"
              disabled={isReturned}
            >
              <i
                className="fas fa-trash"
                style={{
                  cursor: `${isReturned ? "not-allowed" : "pointer"}`,
                  color: "red",
                  fontSize: "1.5rem",
                  opacity: `${isReturned ? "0.5" : "1"}`,
                }}
                onClick={() => {
                  handleDeleteInvoice(
                    row.sales_invoice_id,
                    row.invoice_date,
                    row,
                  );
                }}
              ></i>
            </button>
          </div>
        );
      },
    });
  }

  // Options for customer filter
  const customerOptions = customerList.map((item) => ({
    value: item.customer_id,
    label:
      item.company_name ||
      [item.first_name, item.last_name].filter(Boolean).join(" "),
  }));

  // Options for search filter
  const searchFilter = [
    { value: "client_transaction_id", label: "Transaction ID" },
    { value: "destination", label: "Destination" },
    { value: "invoice_date", label: "Invoice Date" },
    { value: "due_date", label: "Due Date" },
    { value: "dr_number", label: "DR Number" },
    { value: "po_number", label: "PO Number" },
    { value: "total_amount", label: "Total Amount" },
    { value: "product_name", label: "Product Name" },
    { value: "product_code", label: "Product Code" },
    { value: "customer", label: "Customer" },
  ];

  // For customer search filter
  const getCustomers = async () => {
    try {
      const res = await axios.get(
        `${BASE_URL}/invoice/getCustomersDataBySearch`,
        {
          params: {
            customerSearchValue,
          },
        },
      );

      if (res.status === 200) {
        setCustomerList(res.data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const getApiUrl = () => {
    if (debouncedSearchTerm.trim() !== "") {
      return `${BASE_URL}/invoice/getSalesData/search-filter`;
    }
    if (selectedCustomer.length > 0) {
      return `${BASE_URL}/invoice/getSalesData/customer-filter`;
    }
    return `${BASE_URL}/invoice/getSalesData`;
  };

  const pagination = useServerPagination(
    getApiUrl(),
    FilterStore.NIgetPerPage("invoice_returned"),
    {
      startDate: selectedCutOff?.from,
      endDate: selectedCutOff?.to,
      status: ["Returned"],
      currencyId,
      ...(searchTerm.trim() !== "" && {
        searchTerm,
        filterColumn,
      }),
      ...(selectedCustomer.length > 0 && {
        selectedCustomer: selectedCustomer,
      }),
    },
  );

  // No initial sortBy: the backend default (latest first) isn't a visible
  // column, so every header starts neutral until the user picks one
  const sort = useServerSort(pagination);

  const columnsWithReturnItems = columns.map((column) => {
    if (column.name === "Action") {
      return {
        name: "Action",
        selector: (row) => {
          const status = row.status;
          const isReturned = status === "Returned";
          const isPending = status === "Pending";
          const isMenuOpen = openMenuId === row.sales_invoice_id;
          const isRotated = rotatedId === row.sales_invoice_id;

          return (
            <div className="d-flex align-items-center flex-column gap-2 p-3">
              <button
                type="button"
                className="btn btn-sm"
                style={{
                  backgroundColor: "#f8f9fa",
                  color: "#495057",
                  border: "1px solid #dee2e6",
                  borderRadius: "6px",
                  width: "40px",
                  height: "40px",
                  padding: "0",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  transition: "all 0.2s ease-in-out",
                  cursor: "pointer",
                  boxShadow: "0 1px 3px rgba(0, 0, 0, 0.05)",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = "#e9ecef";
                  e.currentTarget.style.borderColor = "#adb5bd";
                  e.currentTarget.style.boxShadow =
                    "0 2px 4px rgba(0, 0, 0, 0.1)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = "#f8f9fa";
                  e.currentTarget.style.borderColor = "#dee2e6";
                  e.currentTarget.style.boxShadow =
                    "0 1px 3px rgba(0, 0, 0, 0.05)";
                }}
                onClick={() => {
                  setOpenMenuId(isMenuOpen ? null : row.sales_invoice_id);
                  setRotatedId(isRotated ? null : row.sales_invoice_id);
                }}
              >
                <i
                  className="fa-solid fa-ellipsis-v"
                  style={{
                    transform: isRotated ? "rotate(0deg)" : "rotate(90deg)",
                    transition: "transform 0.3s ease-in-out",
                  }}
                ></i>
              </button>

              {/* Dropdown Menu */}
              {isMenuOpen && (
                <div
                  className="position-absolute bg-white border rounded shadow-sm "
                  style={{
                    top: "20px",
                    left: "-40px",
                    zIndex: 1000,
                    borderColor: "#dee2e6",
                    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.12)",
                    animation: "slideDown 0.2s ease-out",
                  }}
                >
                  {/* Delete Button */}
                  <button
                    type="button"
                    className="btn btn-link btn-sm text-danger text-decoration-none w-100 text-start p-2 fw-bold"
                    disabled={isReturned}
                    onClick={() => {
                      if (handleDeleteInvoice) {
                        handleDeleteInvoice(
                          row.sales_invoice_id,
                          row.invoice_date,
                          row,
                        );
                      }
                      setOpenMenuId(null);
                      setRotatedId(null);
                    }}
                  >
                    Delete
                  </button>

                  <hr className="m-1" />

                  {/* Return Items Button */}
                  <button
                    type="button"
                    className="btn btn-link btn-sm text-decoration-none w-100 text-start p-2 fw-bold"
                    style={{
                      color: "#FFA500",
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      setSelectedInvoiceData({
                        invoiceId: row.sales_invoice_id,
                        transactionId: row.client_transaction_id,
                      });
                      setShowBackloadModal(true);
                      setOpenMenuId(null);
                      setRotatedId(null);
                    }}
                    disabled={status !== "Approved"}
                  >
                    Return Items
                  </button>
                </div>
              )}
            </div>
          );
        },
      };
    }
    return column;
  });

  // Handle invoice deletion
  const handleDeleteInvoice = async (invoiceId, invoice_date, rowData) => {
    swal({
      title: "Confirm Deletion",
      text: "Are you sure you want to delete?",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async (willDelete) => {
      if (willDelete) {
        try {
          const response = await axios.delete(
            `${BASE_URL}/invoice/deleteInvoice/${invoiceId}/${invoice_date}`,
            {
              data: { userLoggedID, rowData },
            },
          );
          if (response.status === 200) {
            swal({
              title: "Invoice Deleted Successfully!",
              text: "The invoice has been successfully deleted.",
              icon: "success",
              button: "OK",
            }).then(() => {
              fetchCutOff();
            });
          } else if (response.status === 203) {
            const { transactionNumber, moduleType } = response.data;
            let moduleFrom;
            if (moduleType === "Local-Bulk-Collection") {
              moduleFrom = "Local Collection";
            } else {
              moduleFrom = "Overseas Collection";
            }
            const title = document.createElement("div");
            const text = document.createElement("div");
            const swalInfo = document.createElement("div");

            title.innerHTML = `<div style="font-size: 1.5rem; font-weight: bold;">Deletion Prohibited!</div>`;
            text.innerHTML = `<div style="text-align: center; margin-top: 10px;">
                                Delete first the invoice in module <strong>${moduleFrom}</strong> with 
                                Transaction Number: <strong>${transactionNumber}</strong>
                              </div>`;

            swalInfo.append(title);
            swalInfo.append(text);
            swal({
              icon: "error",
              content: swalInfo,
            });
          } else if (response.status === 202) {
            const { invoiceDate, CutoffName } = response.data;
            swal({
              title: "Delete Prohibited!",
              text: `Invoice cannot be deleted as its invoice date (${invoiceDate}) falls within the posted cutoff period named "${CutoffName}".`,
              icon: "warning",
              button: "OK",
            });
          } else {
            swal({
              icon: "error",
              title: "Something went wrong",
              text: "Please contact our support team for assistance.",
            });
          }
        } catch (error) {
          if (error.response.status === 401) {
            swal({
              icon: "error",
              // title: "Please contact your support",
              title: error.response.data.title,
              text: error.response.data.message,
            }); // test 1
          } else {
            console.log(error);
            swal({
              icon: "error",
              title: "Error",
              text: "An error occurred while deleting the invoice.",
            });
          }
        }
      }
    });
  };

  // Handle data table row click
  const handleViewInvoice = (row) => {
    if (row.client_transaction_id?.startsWith("ROT-S")) {
      navigate(`/sales/transaction-invoice-update/${row.sales_invoice_id}`);
    } else {
      navigate(`/sales/invoice-update/${row.sales_invoice_id}?page=1`);
    }
  };

  const handleSearch = (e) => {
    const value = e.target.value;

    // Always update the input display immediately (no lag while typing)
    setSearchTerm(value);

    // Cancel any in-flight debounce timer
    if (debounceTimer.current) clearTimeout(debounceTimer.current);

    // Feature 3: when search is cleared, reset synchronously — no delay needed
    if (!value.trim()) {
      // ⬇ Set ref FIRST (synchronous) so the Feature 2 effect can never
      // fire with the old searchTerm closure while data is still arriving.
      isSearchActiveRef.current = false;
      lastSearchCutoffRef.current = { from: null, to: null };
      setDebouncedSearchTerm(""); // immediate — triggers effect right away on clear
      fetchCutOff(); // reads FilterStore, resets selectedCutOff + refreshes widgets
      return;
    }

    // For non-empty input, mark search active and debounce the actual API call
    isSearchActiveRef.current = true;
    debounceTimer.current = setTimeout(() => {
      setDebouncedSearchTerm(value); // triggers the useEffect → updatePaginationParams
    }, 600);
  };

  const handleFilterColumnSelect = (column) => {
    setFilterColumn(column);
  };

  const handleCustomerChange = (selected) => {
    // CHANGED: handle Select All / uncheck all directly here instead of relying on
    // useEffect + updatePaginationParams, which caused flickering because getApiUrl()
    // sent Select All to /customer-filter instead of the base URL.
    const isSelectAll = selected.length === customerOptions.length;

    if (isSelectAll) {
      // Select All — use base URL, show all data
      pagination.updateApiUrl(`${BASE_URL}/invoice/getSalesData`);
      pagination.updateParams({
        startDate: selectedCutOff?.from,
        endDate: selectedCutOff?.to,
        status: ["Returned"],
        currencyId,
      });
    } else if (selected.length > 0) {
      // Some selected — filter by them
      pagination.updateApiUrl(
        `${BASE_URL}/invoice/getSalesData/customer-filter`,
      );
      pagination.updateParams({
        startDate: selectedCutOff?.from,
        endDate: selectedCutOff?.to,
        status: ["Returned"],
        currencyId,
        selectedCustomer: selected,
      });
    } else {
      // None selected — hide data
      pagination.updateApiUrl(
        `${BASE_URL}/invoice/getSalesData/customer-filter`,
      );
      pagination.updateParams({
        startDate: selectedCutOff?.from,
        endDate: selectedCutOff?.to,
        status: ["Returned"],
        currencyId,
        selectedCustomer: [],
      });
    }
    // END CHANGED

    setSelectedCustomer(selected);
    if (selected.length > 0) {
      setSearchTerm("");
    }
  };

  const updatePaginationParams = () => {
    const apiUrl = getApiUrl();
    pagination.updateApiUrl(apiUrl);

    const isSearching = debouncedSearchTerm.trim() !== "";

    const params = {
      // Feature 1: no date restriction when a search term is active
      startDate: isSearching ? null : selectedCutOff?.from,
      endDate: isSearching ? null : selectedCutOff?.to,
      status: ["Returned"],
      currencyId,
    };

    // Add search params if searching
    if (isSearching) {
      params.searchTerm = debouncedSearchTerm;
      params.filterColumn = filterColumn;
    }

    // Add customer filter params if customers selected
    if (selectedCustomer.length > 0) {
      params.selectedCustomer = selectedCustomer;
    }

    pagination.updateParams(params);
  };

  const handleCloseBackloadModal = () => {
    setShowBackloadModal(false);
    setSelectedInvoiceData({
      invoiceId: null,
      transactionId: null,
    });
  };

  ///PARA ITO SA FILTER RETENTION NG PAGE
  //START
  // Save gate — stays closed until after mount restore settles,
  // so the hook's internal reset-to-1 from updateParams doesn't overwrite the saved page.
  useEffect(() => {
    if (!pageRestored.current) return;
    if (pagination.currentPage) {
      FilterStore.NIsavePage(pagination.currentPage, "invoice_returned");
    }
  }, [pagination.currentPage]);

  useEffect(() => {
    if (pagination.itemsPerPage) {
      FilterStore.NIsavePerPage(pagination.itemsPerPage, "invoice_returned");
    }
  }, [pagination.itemsPerPage]);

  // Restore last viewed page on mount. setTimeout(600) defers until after
  // selectedCutOff → updatePaginationParams → hook's reset-to-1 has settled,
  // then opens the save gate for user navigation.
  useEffect(() => {
    const savedPage = FilterStore.NIgetPage("invoice_returned");
    if (savedPage > 1) {
      setTimeout(() => {
        pagination.setCurrentPage(savedPage);
        pageRestored.current = true;
      }, 600);
    } else {
      setTimeout(() => {
        pageRestored.current = true;
      }, 600);
    }
  }, []);
  //END

  // Feature 2: auto-update the date range picker to span the search results
  useEffect(() => {
    if (!isSearchActiveRef.current || !pagination.data?.length) return;

    const dates = pagination.data
      .map((item) => new Date(item.invoice_date))
      .filter((d) => !isNaN(d.getTime()));

    if (!dates.length) return;

    const minDate = new Date(Math.min(...dates.map((d) => d.getTime())));
    const maxDate = new Date(Math.max(...dates.map((d) => d.getTime())));

    const newFrom = format(minDate, "yyyy-MM-dd");
    const newTo = format(maxDate, "yyyy-MM-dd");

    // Skip if the dates haven't changed — prevents the infinite loop where
    // setSelectedCutOff triggers the main useEffect → re-fetch → new data
    // array ref → Feature 2 fires again → setSelectedCutOff → repeat.
    if (
      lastSearchCutoffRef.current.from === newFrom &&
      lastSearchCutoffRef.current.to === newTo
    )
      return;

    lastSearchCutoffRef.current = { from: newFrom, to: newTo };
    setSelectedCutOff({ id: "search", from: newFrom, to: newTo });
  }, [pagination.data]);

  useEffect(() => {
    updatePaginationParams();
  }, [selectedCutOff, currencyId, debouncedSearchTerm, filterColumn]);

  useEffect(() => {
    getCustomers();
  }, [customerSearchValue]);

  return (
    <div className="container-fluid">
      {/* Customer filter */}
      <div className="row mb-3">
        <div className="col-12 col-md-4">
          <span>Customer</span>
          <MultiSelect
            options={customerOptions}
            value={selectedCustomer}
            onChange={handleCustomerChange}
            labelledBy="Select Customer"
            filterOptions={(options, filter) => {
              setCustomerSearchValue(filter);
              return options.filter(({ label }) =>
                label.toLowerCase().includes(filter.toLowerCase()),
              );
            }}
            debounceDuration={300}
            overrideStrings={{
              selectSomeItems: "Select Customer",
              search: "Search Customer",
            }}
          />
        </div>
      </div>

      {/* Search filter */}
      <div className="w-100 mt-2">
        <div className="input-group">
          <input
            type="text"
            className="form-control"
            placeholder="Search"
            value={searchTerm}
            onChange={handleSearch}
          />
          <button
            type="button"
            className="btn btn-outline-secondary dropdown-toggle-split"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <i className="fa-solid fa-sliders"></i>
          </button>
          <ul className="dropdown-menu dropdown-menu-end">
            <li>
              <button
                className={`dropdown-item ${
                  filterColumn === "all" ? "active" : ""
                }`}
                onClick={() => handleFilterColumnSelect("all")}
              >
                All
              </button>
            </li>
            <li>
              <hr className="dropdown-divider" />
            </li>
            {searchFilter.map(({ value, label }) => (
              <li key={value}>
                <button
                  className={`dropdown-item ${
                    filterColumn === value ? "active" : ""
                  }`}
                  onClick={() => handleFilterColumnSelect(value)}
                >
                  {label}
                </button>
              </li>
            ))}
          </ul>
        </div>
      </div>

      {/* Data table */}
      <div className="mt-3">
        <div className="sales-invoice-data-table">
          <DataTable
            columns={sort.sortColumns(columnsWithReturnItems)}
            data={pagination.data}
            customStyles={customStyles}
            className="dataTable"
            onRowClicked={handleViewInvoice}
            {...sort.sortProps}
          />
          <PaginationControls {...pagination} />
        </div>
      </div>

      <BackloadModal
        show={showBackloadModal}
        onHide={handleCloseBackloadModal}
        invoiceId={selectedInvoiceData.invoiceId}
        transactionId={selectedInvoiceData.transactionId}
        userLoggedID={userLoggedID}
      />
    </div>
  );
};

export default ApprovedStatusTab;
